// extracted by css-extract-rspack-plugin
export default {"HeaderEditorContainer":"HeaderEditor-module__HeaderEditorContainer__a_1fz"};